export const setMachineID = (payload) => {
	return {
		type: "SET_MACHINE_ID",
		data: payload,
	};
};

export const setMachines = (payload) => {
	return {
		type: "SET_MACHINES",
		data: payload,
	};
};